import React from 'react'
import Navbar from './Navbar'
import BannerBackground from "../Assets/home-banner-background.png"
import HuesoReparacion from "../Assets/Recurso2.jpg"
import BannerImage from "../Assets/home-banner-image.png"
import {FiArrowRight} from "react-icons/fi"

const Home = () => {
  return (
    <div id='precios'>
    <Navbar />
    <div className='home-banner-container'>
        <div className='home-bannerImage-container'>
            <img src={BannerBackground} alt="" />            
        </div>
        <div className='home-text-section'>
            <h1 className='primary-heading'>
                Curso de estabilización híbrida interna/externa (HIEF) <br />6 y 7 de junio
            </h1>
            <p className='primary-text'>
                En nuestros talleres aprenderás de los mejores utilizando las más innovadoras técnicas.
            </p>
            <a className='secondary-button' href='https://tlavc-peru.org/insc.php'>
                Inscribirme ahora <FiArrowRight />
            </a>
        </div>
        <div className='home-image-container'>
            <img src={HuesoReparacion} alt="" />            
        </div>
        
    </div>

  </div>
  )
    
}  

export default Home